import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faHashtag, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        nit_operador: '',
        nombre: '',
        rep_legal: '',
        direccion_oper: '',
        correo_electronico_oper: '',
        resp_oper: '',
        cargo_resp_oper: '',
        telefono_resp_oper: '',
        correo_electronico_resp_oper: '',
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const { nit_operador, nombre, rep_legal, direccion_oper, correo_electronico_oper, resp_oper, cargo_resp_oper, telefono_resp_oper, correo_electronico_resp_oper } = this.state;
        var errores = [];
        if (!nombre) { errores.push("error_nombre"); }
        if (!nit_operador) { errores.push("error_nit_operador"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        var datosEnviar = {
            nombre: nombre,
            nit_operador: nit_operador,
            rep_legal: rep_legal,
            direccion_oper: direccion_oper,
            correo_electronico_oper: correo_electronico_oper,
            resp_oper: resp_oper,
            cargo_resp_oper: cargo_resp_oper,
            telefono_resp_oper: telefono_resp_oper,
            correo_electronico_resp_oper: correo_electronico_resp_oper
        }
        Swal.showLoading();
        authAxios.post("operadores/registrar", datosEnviar)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Operadores de Red!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/MasterOperadores");
                } else {
                    Swal.close();
                    Swal.fire(
                        'Operadores de Red!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    render() {
        const { nit_operador, nombre, rep_legal, direccion_oper, correo_electronico_oper, resp_oper, cargo_resp_oper, telefono_resp_oper, correo_electronico_resp_oper } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>REGISTRO DE OPERADORES DE RED</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="nit_operador">NIT Operador de Red</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_nit_operador")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="nit_operador" id="nit_operador" value={nit_operador} placeholder="NIT OPERADOR DE RED" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el NIT Operador de Red</small>
                                                </div>
                                                <div className="col-md-10">
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="nombre" id="nombre" value={nombre} placeholder="NOMBRE" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-4">
                                                    <label htmlFor="rep_legal">Repr. Legal</label>
                                                    <input style={{ textTransform: 'uppercase' }} className="form-control form-control-sm" type="text" name="rep_legal" id="rep_legal" value={rep_legal} placeholder="REPR. LEGAL" aria-describedby="helpId" onChange={this.cambioValor} />
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="direccion_oper">Dirección</label>
                                                    <input style={{ textTransform: 'uppercase' }} className="form-control form-control-sm" type="text" name="direccion_oper" id="direccion_oper" value={direccion_oper} placeholder="DIRECCIÓN" aria-describedby="helpId" onChange={this.cambioValor} />
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="correo_electronico_oper">Correo Electrónico</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faAt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className="form-control form-control-sm" type="text" name="correo_electronico_oper" id="correo_electronico_oper" value={correo_electronico_oper} placeholder="CORREO ELECTRÓNICO" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="resp_oper">Responsable</label>
                                                    <input style={{ textTransform: 'uppercase' }} className="form-control form-control-sm" type="text" name="resp_oper" id="resp_oper" value={resp_oper} placeholder="RESPONSABLE" aria-describedby="helpId" onChange={this.cambioValor} />
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="cargo_resp_oper">Cargo Responsable</label>
                                                    <input style={{ textTransform: 'uppercase' }} className="form-control form-control-sm" type="text" name="cargo_resp_oper" id="cargo_resp_oper" value={cargo_resp_oper} placeholder="CARGO RESPONSABLE" aria-describedby="helpId" onChange={this.cambioValor} />
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="telefono_resp_oper">Telefono Responsable</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className="form-control form-control-sm" type="text" name="telefono_resp_oper" id="telefono_resp_oper" value={telefono_resp_oper} placeholder="TELEFONO RESPONSABLE" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="correo_electronico_resp_oper">Correo Electrónico Responsable</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faAt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className="form-control form-control-sm" type="text" name="correo_electronico_resp_oper" id="correo_electronico_resp_oper" value={correo_electronico_resp_oper} placeholder="CORREO ELECTRÓNICO RESP." aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear Oper. de Red</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterOperadores"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;